<template>
  <div>
    <global-table
      :table-data="customerAsset"
      :loading="loading"
      :per-page="10"
      :table-detail="tableDetail"
      :bordered="true"
      :hover="true"
      :striped="false"
      :id-modals="'customerAssetForm'"
      :redirect-detail="false"
      :edit-button="false"
      :show-add-button="childAddButton"
      :remove-button="childAddButton"
      :fields="fieldsCustomerAsset"
      addButton="Penempatan Asset"
      @editForm="editForm"
      @resetForm="resetForm"
      @removeForm="removeForm"
    ></global-table>

    <b-modal
      ref="customerAssetForm"
      id="customerAssetForm"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Pointing asset ke konsumen</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form id="customerAssetForm" validated novalidate v-on:submit.prevent="saveCustomerAsset">
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="asset_owner_id" label="Nama Barang">
                <model-select
                  id="asset_owner_id"
                  :options="listAssetOwner"
                  v-model="$v.customerAssetForm.asset_owner_id.$model"
                  :isError="$v.customerAssetForm.asset_owner_id.$invalid"
                  @input="onSelectAssetOwner"
                  required
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetForm.asset_owner_id === null"
                  class="invalid-feedback-custom"
                >Nama barang harus di pilih.</div>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <div v-if="!myLoading">
                <b-form-group label-for="asset_id" label="Serial Number">
                  <model-select
                    id="asset_id"
                    :options="listAsset"
                    v-model="$v.customerAssetForm.asset_id.$model"
                    :isError="$v.customerAssetForm.asset_id.$invalid"
                    required
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="customerAssetForm.asset_id === null"
                    class="invalid-feedback-custom"
                  >Serial number harus di pilih.</div>
                  <!-- <b-form-invalid-feedback>Serial number harus di pilih.</b-form-invalid-feedback> -->
                </b-form-group>
              </div>
              <div v-else>
                <loading></loading>
              </div>
            </b-col>
            <b-col sm="3">
              <b-form-group label-for="placement_date" label="Tanggal Penempatan">
                <v-date-picker
                  id="placement_date"
                  :input-props="{ class: 'form-control', placeholder: 'Tanggal Penempatan', required: ''}"
                  :state="!$v.customerAssetForm.placement_date.$invalid"
                  v-model="$v.customerAssetForm.placement_date.$model"
                ></v-date-picker>
                <div
                  v-if="$v.customerAssetForm.placement_date.$invalid"
                  class="invalid-feedback-custom"
                >Tanggal penempatan harus di isi.</div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group label-for="assign_send_to" label="Yang Mengirim">
                <model-select
                  id="assign_send_to"
                  :options="listEmployee"
                  v-model="$v.customerAssetForm.assign_send_to.$model"
                  :isError="$v.customerAssetForm.assign_send_to.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetForm.assign_send_to === null"
                  class="invalid-feedback-custom"
                >Driver yang mengirim harus di isi.</div>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label-for="assign_spv_operational" label="SPV Sales Marketing">
                <model-select
                  id="assign_spv_operational"
                  :options="listEmployee"
                  v-model="$v.customerAssetForm.assign_spv_operational.$model"
                  :isError="$v.customerAssetForm.assign_spv_operational.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetForm.assign_spv_operational === null"
                  class="invalid-feedback-custom"
                >SPV Sales Marketing harus di isi.</div>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label-for="status" label="Status Barang">
                <model-select
                  id="status"
                  :options="listAssetStatus"
                  v-model="$v.customerAssetForm.asset_status.$model"
                  :isError="$v.customerAssetForm.asset_status.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetForm.asset_status === null"
                  class="invalid-feedback-custom"
                >Status Barang harus di isi.</div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group label-for="description_send" label="Deskripsi">
                <b-form-textarea
                  id="description_send"
                  :rows="3"
                  :max-rows="6"
                  v-model="$v.customerAssetForm.description_send.$model"
                  :state="!$v.customerAssetForm.description_send.$invalid"
                ></b-form-textarea>
                <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelCustomerAsset">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="$v.customerAssetForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>

    <b-modal
      ref="customerAssetRemoveForm"
      id="customerAssetRemoveForm"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Hapus pointing asset dari konsumen</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form id="customerAssetRemoveForm" validated novalidate @submit="saveRemoveCustomerAsset">
          <b-row>
            <b-col sm="6">
              <b-form-group label-for="reason" label="Alasan">
                <b-form-textarea
                  id="reason"
                  :rows="3"
                  :max-rows="6"
                  v-model="$v.customerAssetRemoveForm.reason.$model"
                  :state="!$v.customerAssetRemoveForm.reason.$invalid"
                  required
                ></b-form-textarea>
                <b-form-invalid-feedback>Alasan harus di isi.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelRemoveCustomerAsset">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="$v.customerAssetRemoveForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "asset-placement",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    },
    customer: {
      type: [Array, Object],
      default: () => {}
    },
    customerAsset: {
      type: [Array],
      default: () => []
    },
    listAssetOwner: {
      type: [Array],
      default: () => []
    },
    listStatusCustomerAsset: {
      type: [Array],
      default: () => []
    },
    listEmployee: {
      type: [Array],
      default: () => []
    },
    listAssetStatus: {
      type: [Array],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    },
    childAddButton: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    customerAssetForm: {
      asset_id: { required },
      contract_number: {},
      asset_owner_id: { required },
      placement_date: { required },
      asset_status: { required },
      assign_send_to: { required },
      assign_spv_operational: { required },
      description_send: { required }
    },
    customerAssetRemoveForm: {
      reason: { required }
    }
  },
  data() {
    return {
      myCustomer: {},
      myLoading: false,
      loadingSubmit: false,
      listAsset: [],
      fieldsCustomerAsset: [
        {
          key: "contract_number_download",
          label: "Nomor Kontrak",
          sortable: true
        },
        { key: "serial_number", label: "Serial Number" },
        { key: "owner", label: "Pemilik" },
        { key: "asset_name", label: "Nama Barang" },
        { key: "placement_date", label: "Tanggal Penempatan" },
        { key: "status_name", label: "Status" },
        { key: "description_send", label: "Deskripsi" },
        { key: "action", label: "Action", class: "text-center width-100" }
      ],
      customerAssetForm: interfaces.customer_asset,
      customerAssetRemoveForm: { reason: null }
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {},
    reload(cust_id) {
      this.$emit("reload", cust_id);
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.customer_asset) {
        if (a === "status") {
          interfaces.customer_asset[a] = "1";
        } else if (a === "reason") {
          this.customerAssetRemoveForm[a] = null;
        } else {
          interfaces.customer_asset[a] = null;
        }
      }
      this.customerAssetForm = interfaces.customer_asset;
    },
    removeForm: function(data) {
      this.resetForm();
      this.$refs.customerAssetRemoveForm.show();
      this.customerAssetRemoveForm = data;
    },
    saveCustomerAsset: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan asset untuk konsumen ini ?")) {
        this.loadingSubmit = true;
        let customer_asset = this.customerAssetForm;
        customer_asset.customer_id = this.customer.id;
        customer_asset.assigned_by = localStorage.getItem("employee_id");
        customer_asset.request_code = this.customer.request_code;
        this.axios
          .post("web/customer/add-customer-asset/", customer_asset)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah asset konsumen",
                message: response.data.message
              });
            }
            this.cancelCustomerAsset();
          })
          .catch(error => {
            this.expired(error, "Tambah asset konsumen");
          })
          .finally(() => {
            this.loadingSubmit = false;
            //this.reload(this.customer.id);
            this.reload(this.customer.request_id);
          });
      }
    },
    saveRemoveCustomerAsset: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menghapus asset konsumen ini ?")) {
        let customer_asset = this.customerAssetRemoveForm;
        customer_asset.status = "3";
        customer_asset.updated_by = localStorage.getItem("employee_id");
        this.axios
          .put("web/customer/change-customer-asset/", customer_asset)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Hapus asset",
                message: response.data.message
              });
            }
            this.cancelRemoveCustomerAsset();
          })
          .catch(error => {
            this.expired(error, "Hapus asset");
          })
          .finally(() => {
            //this.reload(this.customer.id);
            this.reload(this.customer.request_id);
          });
      }
    },
    cancelCustomerAsset: function() {
      this.$refs.customerAssetForm.hide();
    },
    cancelRemoveCustomerAsset: function() {
      this.$refs.customerAssetRemoveForm.hide();
    },
    onSelectAssetOwner: function(event, asset_id = "") {
      this.customerAssetForm.asset_id = null;
      this.myLoading = true;
      if (asset_id === "") {
        this.axios
          .get("web/dropdown/search-by-asset-owner/" + event + "/")
          .then(response => {
            this.listAsset = response.data.data;
          })
          .catch(error => {})
          .finally(() => {
            this.myLoading = false;
          });
      } else {
        this.axios
          .get(
            "web/dropdown/search-by-asset-owner/" +
              event +
              "/" +
              asset_id +
              "/for-edit"
          )
          .then(response => {
            this.listAsset = response.data.data;
          })
          .catch(error => {})
          .finally(() => {
            this.myLoading = false;
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
